export const NAVIGATION_METHODS = {
  LOBBY: 'lobby',
  URL: 'url',
  POPUP: 'popup',
  TAB: 'tab',
  REPLACE: 'replace',
  POST: 'post',
};
